// Tiny DOM helpers. No framework here on purpose.

/** Create an element. `html` goes straight to innerHTML — escape anything user-typed. */
export function el(tag, className, html) {
  const e = document.createElement(tag);
  if (className) e.className = className;
  if (html != null) e.innerHTML = html;
  return e;
}

/**
 * Escape for innerHTML. Teammates type titles and notes into this app, so every
 * interpolated string must pass through here. Attribute values too — quotes are escaped.
 */
export function esc(s) {
  return String(s).replace(/[&<>"]/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[m]));
}

export function byId(id) {
  return document.getElementById(id);
}

/** Keys of an object whose values are truthy — used for the on/off filter maps. */
export function truthyKeys(o) {
  return Object.keys(o).filter((k) => o[k]);
}

/** Read from localStorage without throwing in private windows or embedded contexts. */
export function readLocal(key, fallback) {
  try {
    const v = localStorage.getItem(key);
    return v === null ? fallback : v;
  } catch {
    return fallback;
  }
}

export function writeLocal(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* private window, blocked storage — losing a UI preference is fine */
  }
}
